// removed by extract-text-webpack-plugin
module.exports = {"heading_reset":"Heading--heading_reset--1UMrE","h1_style":"Heading--h1_style--3S4_8","h2_style":"Heading--h2_style--3dDjz","h3_style":"Heading--h3_style--FejVQ","h4_style":"Heading--h4_style--24eyC","h5_style":"Heading--h5_style--hGTZk","h6_style":"Heading--h6_style--3MknT"};


//////////////////
// WEBPACK FOOTER
// /src/~/@healthwise/enhanced-shared-decision-point/components/Heading/Heading.css
// module id = 1021
// module chunks = 0